import type { WorkPackage } from "./agentExecutionContract";

import type { AgentDefinition } from "./agentRegistry";

import { AgentRegistry } from "./agentRegistry";

export class AgentAssignmentService {
  constructor(private readonly registry: AgentRegistry) {}

  assign(workPackage: WorkPackage): AgentDefinition {
    const verificationRequired =
      workPackage.department === "SECURITY" || workPackage.department === "QA";

    const eligible = this.registry.eligible({
      department: workPackage.department,

      requiredAuthorities: workPackage.authorities,

      verificationRequired,
    });

    if (!eligible.length) {
      throw new Error(`No eligible agent for work item ${workPackage.id}.`);
    }

    return eligible[0]!;
  }
}
